import * as React from "react";
import './components.css';

export type InputProps = {
  action?: React.ReactNode;
  disabled?: boolean;
  error?: string | boolean | null;
  id?: string;
  label: string;
  name?: string;
  type?: "text" | "password" | "date";
  inputClass?:string;
  icon?: string;
  help?:string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { action, disabled, error, id, label, name, type = "text",inputClass="",icon,help,onChange},
  ref
) {
  return (
    <div className="mb-3">
        <label className="form-label" htmlFor={name}>{label}</label>
        <div style={{position: 'relative'}}>
        {icon && typeof icon === "string" && <i className={icon} style={{position:'absolute',top:'17px',left:'16px'}}></i>}
        <input {...ref} type={type} name={name} id={id} disabled={disabled}
          className={'form-control form-control-lg ' + inputClass + (error ? ' is-invalid':'')+(icon ? ' with-icon':'')} placeholder={label}
          onChange={(event) => onChange?.(event)}
        />
        {typeof error === "string" && <div className="invalid-feedback">{error}</div>}
        {action}
        {help && typeof help === "string" && <div className="help form-text">{help}</div>}
        </div>
    </div>
  );
});

export default Input;
